module.exports = __webpack_public_path__ + "img/pricat.814dc2a2.png";